export default "__VITE_ASSET__Bjy9IOKm__"